import React from 'react';
import ReactDOM from 'react-dom/client';
import QRScanner from './QRScanner';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<QRScanner />);